import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarruselComponent } from './carrusel.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ProductcardModule } from '../productcard/productcard.module';



@NgModule({
  declarations: [
    CarruselComponent
  ],
  entryComponents: [
    CarruselComponent
  ],
  exports: [
    CarruselComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    ProductcardModule
  ]
})
export class CarruselModule { }
